
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./transactions.cjs.production.min.js')
} else {
  module.exports = require('./transactions.cjs.development.js')
}
